import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ResourceColumn, ResourceListPage } from '../../components/resource/ResourceListPage';
import { Operador } from '../../types/pessoas';
import { operadoresService } from '../../services';

const columns: ResourceColumn<Operador>[] = [
  { header: "Nome", accessor: "nome" },
  { header: "Cargo", accessor: "cargo" },
  { header: "Status", accessor: "status" },
  { header: "Admissão", accessor: "data_admissao" },
  { header: "Qualificações", render: (item) => item.qualificacoes || "-" }
];

export const OperadoresListPage: React.FC = () => {
  const navigate = useNavigate();

  return (
  <ResourceListPage
    title="Operadores"
    description="Equipe operacional cadastrada."
    columns={columns}
    service={operadoresService}
    createPath="/admin/pessoas/operadores/novo"
      onEdit={(item) => item.id && navigate("/admin/pessoas/operadores/editar", { state: { record: item } })}
  />
  );
};